export const GET_ALL_PRODUCT = "GET_ALL_PRODUCT"
export const GET_ALL_PRODUCT_SUCCESS = "GET_ALL_PRODUCT_SUCCESS"
export const GET_ALL_PRODUCT_ERROR = "GET_ALL_PRODUCT_ERROR"
